import { render, staticRenderFns } from "./Dog-list.vue?vue&type=template&id=36602e6e&scoped=true&"
import script from "./Dog-list.vue?vue&type=script&lang=js&"
export * from "./Dog-list.vue?vue&type=script&lang=js&"
import style0 from "./Dog-list.vue?vue&type=style&index=0&id=36602e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36602e6e",
  null
  
)

export default component.exports